"use client";

import { useTranslations } from "next-intl";
import {
  EMAIL_OTP_LENGTH,
  NON_DIGIT_PATTERN,
} from "../verification/verification.constants";
import { Button } from "@artha/ui";
import { PERSONALIZATION_FIELD_CLASS_NAME } from "../../personalization.utils";

import type { OtpStepProps } from "../verification/verification.types";

export function OtpStep({
  submitLabel,
  code,
  email,
  isRequestingCode,
  isVerifying,
  onCodeChange,
  onSubmit,
  onResend,
}: OtpStepProps) {
  const t = useTranslations("profile.resumePersonalization");

  return (
    <form
      className="space-y-4"
      onSubmit={(event) => {
        event.preventDefault();
        onSubmit();
      }}
    >
      <p className="text-sm text-[#667085]">
        {isRequestingCode ? t("otp.sending") : t("otp.sent", { email })}
      </p>
      <input
        type="text"
        inputMode="numeric"
        autoComplete="one-time-code"
        maxLength={EMAIL_OTP_LENGTH}
        aria-label={t("otp.codeLabel")}
        value={code}
        disabled={isRequestingCode}
        className={`${PERSONALIZATION_FIELD_CLASS_NAME} text-center text-xl font-bold tracking-[0.35em]`}
        onChange={(event) =>
          onCodeChange(
            event.target.value
              .replace(NON_DIGIT_PATTERN, "")
              .slice(0, EMAIL_OTP_LENGTH),
          )
        }
      />
      <Button
        type="submit"
        className="h-12 w-full rounded-[10px] bg-primary font-bold text-primary-foreground"
        disabled={isRequestingCode || isVerifying}
      >
        {isRequestingCode
          ? t("actions.sendingCode")
          : isVerifying
            ? t("actions.verifying")
            : (submitLabel ?? t("actions.verify"))}
      </Button>
      <button
        type="button"
        className="w-full text-center text-sm font-semibold underline"
        disabled={isRequestingCode}
        onClick={onResend}
      >
        {t("actions.resendCode")}
      </button>
    </form>
  );
}
